import {
    Grid,
    IconButton,
    Tooltip,
    Button,
    Box,
    Typography,
} from '@mui/material';
import FieldText from '../../../../components/general/fields/fieldText';
import DeleteIcon from '@mui/icons-material/Delete';
import { FormikProps } from 'formik';
import { SingleDynamicField } from '../../../../../shared/types/assistant';
import { ReactNode } from 'react';

interface SingleFieldDynamicFieldsProps {
    formik: FormikProps<{ [key: string]: SingleDynamicField[] }> | undefined;
    name: string;
    label?: string;
    description?: string;
    example?: ReactNode;
    rows?: number;
}

export const SingleFieldDynamicFields = ({
    formik,
    name,
    label,
    description,
    example,
    rows = 5,
}: SingleFieldDynamicFieldsProps) => {
    const fieldValues = formik?.values[name] || [];

    const handleAddField = () => {
        formik?.setFieldValue(name, [...fieldValues, { value: '' }]);
    };

    const handleRemoveField = (index: number) => {
        formik?.setFieldValue(
            name,
            fieldValues.filter((_, i) => i !== index)
        );
    };

    const handleFieldChange = (index: number, value: string) => {
        const updatedFields = [...fieldValues];
        updatedFields[index] = { value };
        formik?.setFieldValue(name, updatedFields);
    };

    return (
        <Box>
            <Typography variant="h6" gutterBottom>
                {label}
            </Typography>

            {description && (
                <Typography color="text.secondary">{description}</Typography>
            )}

            {example && (
                <Box mt={2}>
                    <Typography color="text.secondary">
                        <strong>Ejemplo:</strong>
                    </Typography>
                    {example}
                </Box>
            )}

            <Box mt={2} display="flex" justifyContent="start">
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleAddField}
                >
                    Agregar otra
                </Button>
            </Box>

            {fieldValues.map((fieldItem, index) => (
                <Grid container spacing={2} key={index} pt="20px">
                    <Grid item xs={12} sm={11} md={11.5}>
                        <FieldText
                            label="Descripción"
                            name={`${name}[${index}].value`}
                            size="small"
                            required
                            onBlur={formik?.handleBlur}
                            touched={formik?.touched?.[name]?.[index]?.value}
                            errors={
                                (
                                    formik?.errors?.[name]?.[
                                        index
                                    ] as SingleDynamicField
                                )?.value
                            }
                            value={fieldItem.value}
                            onChange={(e) =>
                                handleFieldChange(index, e.target.value)
                            }
                            rows={rows}
                        />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={1}
                        md={0.5}
                        display="flex"
                        alignItems="center"
                        justifyContent="end"
                    >
                        <Tooltip title="Eliminar">
                            <IconButton
                                size="small"
                                onClick={() => handleRemoveField(index)}
                            >
                                <DeleteIcon sx={{ color: 'error.main' }} />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                </Grid>
            ))}
        </Box>
    );
};
